/* eslint-disable no-underscore-dangle */
const dayjs = require('dayjs');
const utc = require('dayjs/plugin/utc');
const timezone = require('dayjs/plugin/timezone');

dayjs.extend(utc);
dayjs.extend(timezone);

exports.formatNumber = (inputString) => {
  if (!inputString) return '-';

  // Garde seulement les chiffres
  const cleaned = inputString.replace(/\D/g, '');

  // Si trop court, retourne tel quel
  if (cleaned.length < 8) return cleaned;

  // Identifier la partie initiale (tout ce qui dépasse 9 chiffres)
  const prefixLength = cleaned.length - 9;
  const prefix = cleaned.substring(0, prefixLength);
  const rest = cleaned.substring(prefixLength);

  const part1 = rest.substring(0, 2);
  const part2 = rest.substring(2, 5);
  const part3 = rest.substring(5, 8);
  const part4 = rest.substring(8);

  return `${prefix}${prefix ? ' ' : ''}${part1} ${part2} ${part3} ${part4}`;
};

exports.formatDate = (isoDate) => dayjs(isoDate).format('DD MMMM YYYY');
exports.formatDateTime = (isoDate) => dayjs(isoDate).tz('Indian/Antananarivo').format('HH:mm:ss - DD MMMM YYYY .');

exports.formatSeconds = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.round(seconds % 60);

  const result = [];
  if (hours > 0) result.push(`${hours}h`);
  if (minutes > 0) result.push(`${minutes}m`);
  if (remainingSeconds > 0 || result.length === 0) result.push(`${remainingSeconds}s`);

  return result.join(' ');
};

/**
 * @name getRoleResponse
 * @description Returns color and label based on user role (malagasy roles)
 * @param {string} role - User role
 * @param {boolean} inverse - Optional: apply inverse color
 * @returns {{ color: string, label: string }}
 */
exports.getRoleResponse = (role, inverse = false) => {
  // Map des rôles normalisés
  const rolesMap = {
    'mpiandraikitra kely': { color: 'lime', label: 'Mpiandraikitra kely' },
    'mpiandraikitra be': { color: 'orange', label: 'Mpiandraikitra be' },
    mpiandry: { color: 'geekblue', label: 'Mpiandry' },
    'solom pitandrina': { color: 'volcano', label: 'Solo-mpitandrina' },
    solompitandrina: { color: 'volcano', label: 'Solo-mpitandrina' },
    reverend: { color: 'purple', label: 'Reverend' },
    pasteur: { color: 'cyan', label: 'Pasteur' },
    'pasteur stagiaire': { color: 'gold', label: 'Pasteur Stagiaire' },
    'mpino tsotra': { color: 'blue', label: 'Mpino tsotra' },
    'tsy misy': { color: 'blue', label: 'Mpino tsotra' }
  };

  const defaultRole = { color: 'default', label: 'User' };

  // Normaliser la clé
  const normalizedKey = normalizeRoleKey(role);

  const roleData = rolesMap[normalizedKey] || defaultRole;

  // Si inverse = true, on garde la couleur simple (ex: 'lime')
  // Sinon on ajoute '-inverse' (ex: 'lime-inverse')
  const color = inverse ? roleData.color : `${roleData.color}-inverse`;

  return {
    color,
    label: roleData.label
  };
};

/**
 * @name normalizeRoleKey
 * @description Nettoie une chaîne (supprime accents, tirets, espaces, met en minuscule)
 * @param {string} str
 * @returns {string}
 */
normalizeRoleKey = (str) => str
  ?.toString()
  .normalize('NFD') // Supprime accents
  .replace(/[\u0300-\u036f]/g, '') // Enlève marques diacritiques
  .replace(/-/g, ' ') // Remplace tirets par espaces
  .replace(/\s+/g, ' ') // Enlève espaces multiples
  .trim()
  .toLowerCase();

/**
   * @name normalizeCardTypeKey
   * @description Nettoie une chaîne pour comparer le card-type
   * @param {string} str
   * @returns {string}
   */
const normalizeCardTypeKey = (str) => str
  ?.toString()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/-/g, ' ')
  .replace(/\s+/g, ' ')
  .trim()
  .toLowerCase();

/**
   * @name getCardTypeResponse
   * @description Returns color and label based on card type
   * @param {string} cardType - Type de carte (tsotra, premium, vip)
   * @param {boolean} inverse - Optional: appliquer suffixe -inverse
   * @returns {{ color: string, label: string }}
   */

exports.getCardTypeResponse = (cardType, inverse = false) => {
  const cardMap = {
    tsotra: { color: 'cyan', label: 'Tsotra' },
    premium: { color: 'red', label: 'Premium' },
    vip: { color: 'gold', label: 'VIP' }
  };

  const defaultType = { color: 'transparent', label: 'Standard' };

  const normalizedKey = normalizeCardTypeKey(cardType);
  const cardData = cardMap[normalizedKey] || defaultType;

  const color = inverse ? cardData.color : `${cardData.color}-inverse`;

  return {
    color,
    label: cardData.label
  };
};

exports.formatEvents = (data) => {
  const events = [];

  data.forEach((row) => {
    if (row) {
      events.push({
        id: row?._id,
        title: row?.serviceName,
        end: dayjs(row?.createdAt).tz('Indian/Antananarivo').format('YYYY-MM-DD HH:mm'),
        start: dayjs(row?.createdAt).tz('Indian/Antananarivo').format('YYYY-MM-DD HH:mm')
      });
    }
  });

  return events;
};
